// extracted by mini-css-extract-plugin
module.exports = {"contentModal":"CreateSegment_contentModal__1OSkT","modalRadioGroup":"CreateSegment_modalRadioGroup__uu1Bl"};